module.exports = __webpack_public_path__ + "static/img/32.179a5efe.png";